import { Link } from 'gatsby';
import React from 'react';
import { Disclosure } from '@headlessui/react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';

import brandLogo from '../images/kalinga/brand-logo.png';

function Header() {
  const navigation = [
    { name: 'Projects', href: '/projects' },
    { name: 'Diligence', href: '/diligence' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-background bg-opacity-95 backdrop-blur border-b border-border">
      <Disclosure as="nav">
        {({ open }) => (
          <>
            <div className="max-w-screen-xpad mx-auto px-4 md:px-10">
              <div className="flex items-center justify-between h-16 md:h-20">
                <Link to="/" className="flex items-center flex-shrink-0">
                  <img
                    src={brandLogo}
                    alt="LongStraw Carbon"
                    className="h-9 w-auto"
                    width="120"
                    height="36"
                  />
                </Link>
                <div className="hidden md:block">
                  <div className="ml-10 flex items-center gap-8">
                    {navigation.map(({ name, href }) => (
                      <Link
                        key={name}
                        to={href}
                        className="nav-link"
                      >
                        {name}
                      </Link>
                    ))}
                  </div>
                </div>
                <div className="hidden md:block">
                  <Link
                    to="/diligence"
                    className="button-primary"
                  >
                    Request diligence access
                  </Link>
                </div>
                <div className="-mr-2 flex md:hidden">
                  <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded text-foreground hover:text-accent hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="md:hidden border-t border-border">
              <div className="px-4 pt-2 pb-4 space-y-1 sm:px-6">
                {navigation.map(({ name, href }) => (
                  <Link
                    key={name}
                    to={href}
                    className="nav-link block px-3 py-2"
                  >
                    {name}
                  </Link>
                ))}
                <Link
                  to="/diligence"
                  className="button-primary block w-full text-center mt-3"
                >
                  Request diligence access
                </Link>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </header>
  );
}

export default Header;
